module.exports = __webpack_public_path__ + "img/hfg_of110122_03k.45fcd0ff.jpg";